<template>
  <transition name="fade">
    <div class="level3-modal-container" v-if="direkturData">
      <div class="lv3-title-text">
        {{
          $store.state.addEdit.isAddDirektur
            ? 'Tambah Direktur'
            : 'Edit Direktur'
        }}
      </div>
      <div class="lv3-edit-form" style="overflow-y: hidden !important">
        <div class="edit-form-wrapper">
          <div>Jabatan</div>
          <input class="lv3-input-text" :placeholder="inputJabatan" type="text" v-model="inputJabatan"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="edit-form-wrapper">
          <div>Nama</div>
          <input class="lv3-input-text" :placeholder="inputName" type="text" v-model="inputName"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="edit-form-wrapper">
          <div>Nomor Handphone</div>
          <input class="lv3-input-text" :placeholder="inputPhone" type="text" v-model="inputPhone" />
        </div>
        <div class="edit-form-wrapper">
          <div>Email</div>
          <input class="lv3-input-text" :placeholder="inputEmail" type="text" v-model="inputEmail"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="delData()" v-if="!$store.state.addEdit.isAddDirektur">
            DELETE
          </div>
          <div class="email-button" @click="closeModal()">CANCEL</div>
          <div class="email-button" @click="confirm()">CONFIRM</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['propsData'],
  data() {
    return {
      email: null,
      customText: null,
      tempText: null,
      id: '',
      vendor_id: '',
      jabatan: '',
      name: '',
      phoneNumber: '',
      email: '',
    }
  },
  computed: {
    direkturData() {
      const direktur = this.$store.state.addEdit.direkturDetail
      if (direktur) {
        this.id = direktur.id
        this.vendor_id = direktur.vendor_id
        this.jabatan = direktur.jabatan
        this.name = direktur.nama
        this.phoneNumber = direktur.no_handphone
        this.email = direktur.email
      }
      return true
    },
    inputJabatan: {
      get() {
        return this.jabatan
      },
      set(newValue) {
        this.jabatan = newValue
      },
    },
    inputName: {
      get() {
        return this.name
      },
      set(newValue) {
        this.name = newValue
      },
    },
    inputPhone: {
      get() {
        return this.phoneNumber
      },
      set(newValue) {
        this.phoneNumber = newValue
      },
    },
    inputEmail: {
      get() {
        return this.email
      },
      set(newValue) {
        this.email = newValue
      },
    },
  },
  methods: {
    closeModal() {
      const self = this
      self.$store.commit('modalStore/SET_DIREKTUR_MODAL', false)
    },
    checkForm() {
      let arr = [
        [this.inputName, 'Nama Direktur'],
        [this.inputPhone && this.inputPhone.length > 3, 'No Telepon'],
        [this.isEmailValid(this.email), 'Email'],
      ]

      return this.multiConditions(arr)
    },
    confirm() {
      if (this.checkForm()) {
        this.submit()
      }
    },
    submit() {
      if (this.$store.state.addEdit.isAddDirektur) {
        this.$store.dispatch('addEdit/addDirektur', {
          id: this.id,
          vendor_id: this.vendor_id,
          jabatan: this.jabatan,
          nama: this.name,
          no_handphone: this.phoneNumber,
          email: this.email,
          onSuccess: () => {
            this.$store.commit('level1/GET_INFO_DATA', 'informasi')
          },
        })
      } else {
        this.$store.dispatch('addEdit/editDirektur', {
          id: this.id,
          vendor_id: this.vendor_id,
          jabatan: this.jabatan,
          nama: this.name,
          no_handphone: this.phoneNumber,
          email: this.email,
          onSuccess: () => {
            this.$store.commit('level1/GET_INFO_DATA', 'informasi')
          },
        })
      }
    },
    delData() {
      this.$store.dispatch('addEdit/deleteDirektur', {
        id: this.id,
        onSuccess: () => {
          this.$store.commit('level1/GET_INFO_DATA', 'informasi')
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/components/login.scss';
</style>
